__turbopack_context__.v({
  "container": "Search-module-scss-module__ewu7nG__container",
  "input": "Search-module-scss-module__ewu7nG__input",
  "input--open": "Search-module-scss-module__ewu7nG__input--open",
  "input-wrapper": "Search-module-scss-module__ewu7nG__input-wrapper",
  "list": "Search-module-scss-module__ewu7nG__list",
  "list-item": "Search-module-scss-module__ewu7nG__list-item",
  "list-item--highlighted": "Search-module-scss-module__ewu7nG__list-item--highlighted",
  "submit": "Search-module-scss-module__ewu7nG__submit",
});
